"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Header;
var _polished = require("polished");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

const Container = _styledComponents.default.div`
  color: ${({
  theme
}) => theme.colors.white};
  font: ${({
  theme
}) => theme.fonts.robotoMono};
  font-size: 14px;
  font-weight: 400;
  padding-bottom: ${({
  theme
}) => (0, _polished.rem)(theme.spacing[3])};
  text-transform: uppercase;
`;
function Header({
  text
}) {
  return /*#__PURE__*/_react.default.createElement(Container, null, text);
}